import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, NestedProperty, Validation } from "../../decorators/EntityDecorators";
import { Visit } from "./Visit.model";
import { PointOfService } from "./PointOfService.model";
import { RegexType } from "../../services/RegexPatternLibrary";

export class Feedback extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  score: number = 0;

  @Validation({ propertyType: RegexType.Alphabetic })
  comment?: string;

  fK_Visit?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_PointOfService!: number;

  @NestedProperty({ TargetType: Visit })
  visit?: Visit;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  GetType(): IEntityMetaData {
    return Feedback.getMetaData();
  }
}
